
import { useRouter } from '@/lib/navigation';
import Navbar from '@/components/help-center/Navbar';
import Hero from '@/components/help-center/Hero';
import Footer from '@/components/help-center/Footer';
import { articlesByCategory } from '@/lib/articles';
import { getGuideCategoryHref, getGuideHref } from '@/lib/guide-routes';

export function GuidePageShell({ children }: { children: React.ReactNode }) {
  const router = useRouter();

  function handleSelectCategory(category: string, articleId?: number) {
    if (articleId != null) {
      const article = articlesByCategory[category]?.find((a) => a.id === articleId);
      if (article) {
        router.push(getGuideHref(category, article.slug));
        return;
      }
    }
    router.push(getGuideCategoryHref(category));
  }

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <Hero compact onSelectCategory={handleSelectCategory} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
